import init from './services/lock';

export const lock = { init };
export default { lock };
